import { Box } from '@mui/material'
import React from 'react'

const TypingIndicator = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        mt: "-9px",
        '& span': {
          width: '5px',
          height: '5px',
          backgroundColor: 'primary.main', // Replace with the theme's primary color
          display: 'inline-block',
          margin: '1px',
          borderRadius: '50%',
          animation: 'bounce 1s infinite',
          '&:nth-of-type(2)': {
            animationDelay: '0.2s',
          },
          '&:nth-of-type(3)': {
            animationDelay: '0.4s',
          },
        },
        '@keyframes bounce': {
          '0%': { transform: 'translateY(0px)' },
          '50%': { transform: 'translateY(8px)' },
          '100%': { transform: 'translateY(0px)' },
        },
      }}
    >
      <span></span>
      <span></span>
      <span></span>
    </Box>
  )
}

export default TypingIndicator